export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveAccountPlanInfo(context, __apiOptions = {}){
      const getAccountInfoProc = async () => {
        // アカウント情報取得
        return await context.dispatch('api/getAccountInfo', { request_current_disk_byte: true, __apiOptions: structuredClone(__apiOptions) }, {root: true});
      }
      const getAccountLicenseProc = async () => {
        // アカウントライセンス情報取得
        return await context.dispatch('api/getAccountLicense', { __apiOptions: structuredClone(__apiOptions) }, {root: true});
      }
      const [accountDetailInfo, accountLicenseInfo] = await Promise.all([
        getAccountInfoProc(),
        getAccountLicenseProc(),
      ])
      if (!accountDetailInfo || !accountLicenseInfo) {
        return;
      }
      return { accountDetailInfo, accountLicenseInfo }
    },
  },
}
